import { render } from "./ReportsByNumber.vue?vue&type=template&id=281507ec&scoped=true&ts=true&lang=pug"
import script from "./ReportsByNumber.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReportsByNumber.vue?vue&type=script&lang=ts&setup=true"

import "./ReportsByNumber.vue?vue&type=style&index=0&id=281507ec&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-281507ec"]])

export default __exports__